export const BASE_URL = "https://qr.billsarthi.in";
export const PUBLIC_BASE_URL = `${BASE_URL}/public`;
export const API_BASE_URL = `${PUBLIC_BASE_URL}/api`;
export const API_BASE = API_BASE_URL;

export const IMAGE_BASE_URL = `${PUBLIC_BASE_URL}/`;
// export const BASE_URL = "https://qr.billsarthi.in";
// export const PUBLIC_BASE_URL = `${BASE_URL}/public`;
// export const BASE_URL = "https://qr.gamingcafemanager.com";
// export const PUBLIC_BASE_URL = `${BASE_URL}`;
export const MANAGE_URL = `${PUBLIC_BASE_URL}/manage/qrcode`;

export const API_ENDPOINTS = {
  // Auth & Profile
  LOGIN: `${API_BASE_URL}/login/restro`,
  
  REGISTER: `${API_BASE_URL}/register`,
  VERIFY_PHONE: `${API_BASE_URL}/verifyphone`,
  CHECK_VALID: `${API_BASE_URL}/checkvalid`,
  EDIT_PROFILE: `${API_BASE_URL}/edit/profile`,

  // Table operations
  LIST_TABLE: `${API_BASE_URL}/list/table`,
  ADD_TABLE: `${API_BASE_URL}/add/tablenew`,
  UPDATE_TABLE: `${API_BASE_URL}/update/table`,
  DELETE_TABLE: `${API_BASE_URL}/delete/table`,

  // Product & Category
  LIST_PRODUCT_CATEGORY: `${API_BASE_URL}/list/productcategory`,
  PRODUCT_LIST_MASTER: `${API_BASE_URL}/product/list/master`,
  GET_PRODUCT_LIST: `${API_BASE_URL}/list/getproductlist`,
  ADD_PRODUCT_CATEGORY: `${API_BASE_URL}/add/addproductcategory`,
  ADD_PRODUCT: `${API_BASE_URL}/add/addproduct`,
  EDIT_PRODUCT: `${API_BASE_URL}/edit/product`,
  DELETE_PRODUCT: `${API_BASE_URL}/delete/product`,
  PRODUCT_REORDER: `${API_BASE_URL}/product/reorder`,

  // Product Variants & Addons
  PRODUCT_VARIANTS_LIST: `${API_BASE_URL}/product/variants/list`,
  PRODUCT_VARIANTS_SAVE: `${API_BASE_URL}/product/variants/save`,
  PRODUCT_ADDONS_LIST: `${API_BASE_URL}/product/addons/list`,
  PRODUCT_ADDONS_SAVE: `${API_BASE_URL}/product/addons/save`,
  PRODUCT_ADDONS_ASSIGN: `${API_BASE_URL}/product/addons/assign`,
  PRODUCT_ADDONS_BY_PRODUCT: `${API_BASE_URL}/product/addons/by-product`,
  PRODUCT_ADDONS_MAP: `${API_BASE_URL}/product/addons/map`,

  // AI Image Generation
  AI_GENERATE_IMAGE: `${API_BASE_URL}/ai/generate-image`,
  AI_GENERATE_IMAGE_FALLBACK: `${API_BASE_URL}/ai/generate-image-fallback`,
  AI_RESTAURANT_MANAGER: `${API_BASE_URL}/ai/restaurant-manager`,

  // Orders
  CREATE_ORDER: `${API_BASE_URL}/create/order`,
  EDIT_ORDER: `${API_BASE_URL}/edit/order`,
  GET_ORDER_LIST: `${API_BASE_URL}/getorderlist`,
  GET_ORDER_DETAIL: `${API_BASE_URL}/getorderdetail`,
  BULK_CREATE_ORDER: `${API_BASE_URL}/create/order/bulk`,
  DELETE_ORDER: `${API_BASE_URL}/dashboard/delete-order`,
  UPDATE_ORDER_META: `${API_BASE_URL}/order/update-meta`,
  LIST_DELETED_ORDERS: `${API_BASE_URL}/deleted-orders/list`,
  RESTORE_DELETED_ORDER: `${API_BASE_URL}/deleted-orders/restore`,

  // KOT
  CREATE_KOT: `${API_BASE_URL}/create/kot`,
  LIST_KOTS: `${API_BASE_URL}/staff/kitchen/kots`,
  UPDATE_KOT_STATUS: `${API_BASE_URL}/kitchen/kotitem/update-status`,
  DELETE_KOT_ITEM: `${API_BASE_URL}/kitchen/kotitem/delete`,
  KITCHEN_DASHBOARD: `${API_BASE_URL}/kitchen/dashboard`,

  // QR Code Management
  MY_QR_CODE_LIST: `${API_BASE_URL}/myqrcodelist`,
  LIST_ORDER_FROM_QR: `${API_BASE_URL}/list/orderfromQR`,
  QR_ENTITLEMENT_STATUS: `${API_BASE_URL}/qr/entitlement-status`,
  QR_DEATTACH: `${API_BASE_URL}/deattach`,
  QR_ASSIGN_TABLE: `${API_BASE_URL}/qr/assign-table`,
  QR_DELETE: `${API_BASE_URL}/qr/delete`,
  QR_AUTO_PROVISION: `${API_BASE_URL}/qr/auto-provision`,

  // Waiter & Staff
  LIST_WAITER: `${API_BASE_URL}/list/waiter`,
  ADD_STAFF: `${API_BASE_URL}/owner/add-staff`,

  // Party & khatabook
  LIST_PARTY_FOR_ORDERS: `${API_BASE_URL}/list/partylistfororders`,
  CREATE_PARTY: `${API_BASE_URL}/create/party`,
  LOYALTY_SETTINGS: `${API_BASE_URL}/loyalty/settings`,
  LOYALTY_CUSTOMER: (partyId) => `${API_BASE_URL}/loyalty/customer/${partyId}`,
  LOYALTY_CUSTOMERS: `${API_BASE_URL}/loyalty/customers`,
  LOYALTY_REDEMPTION_PREVIEW: `${API_BASE_URL}/loyalty/redemption-preview`,

  // Reports (v2 and general)
  REPORT_SALES: `${API_BASE_URL}/report-v2/sales`,
  REPORT_CUSTOM_EXCEL: `${API_BASE_URL}/report-v2/custom-excel`,
  REPORT_TABLE_WISE_PRODUCT_SALES: `${API_BASE_URL}/report-v2/table-wise-product-sales`,
  REPORT_DAY_WISE_ITEMS: `${API_BASE_URL}/report-v2/day-wise-items`,
  REPORT_MONTH_WISE_ITEMS: `${API_BASE_URL}/report-v2/month-wise-items`,
  REPORT_DISCOUNTED_ORDERS: `${API_BASE_URL}/report-v2/discounted-orders`,
  REPORT_TOP_PRODUCTS: `${API_BASE_URL}/report/top-products`,

  // Inventory
  INVENTORY_ITEMS: `${API_BASE_URL}/inventory/items`,
  INVENTORY_CONFIG: `${API_BASE_URL}/inventory/config`,
  INVENTORY_STOCK_IN: `${API_BASE_URL}/inventory/stock-in`,
};
